__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = function(name, initScope) {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = function(msg) {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "contrast-ui";
	var register = function(name, version, factory, eager) {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = function(id) {
		var handleError = function(err) { warn("Initialization of sharing external failed: " + err); };
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = function(module) { return module && module.init && module.init(__webpack_require__.S[name], initScope); }
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@contrast-security-inc/design-system-alerts", "1.4.3", function() { return Promise.all([__webpack_require__.e(59), __webpack_require__.e(648), __webpack_require__.e(410), __webpack_require__.e(797), __webpack_require__.e(467)]).then(function() { return function() { return __webpack_require__(648648); }; }); });
			register("@contrast-security-inc/design-system-foundations", "5.1.3", function() { return Promise.all([__webpack_require__.e(705), __webpack_require__.e(716), __webpack_require__.e(410), __webpack_require__.e(848)]).then(function() { return function() { return __webpack_require__(49716); }; }); });
			register("@emotion/css", "11.11.2", function() { return Promise.all([__webpack_require__.e(743), __webpack_require__.e(569)]).then(function() { return function() { return __webpack_require__(132196); }; }); });
			register("react-dom", "18.3.1", function() { return function() { return __webpack_require__(440961); }; }, 1);
			register("react-hook-form", "7.72.0", function() { return __webpack_require__.e(785).then(function() { return function() { return __webpack_require__(349785); }; }); });
			register("react-query", "3.39.3", function() { return function() { return __webpack_require__(41337); }; }, 1);
			register("react-router-dom", "6.30.3", function() { return function() { return __webpack_require__(575431); }; }, 1);
			register("react", "18.3.1", function() { return function() { return __webpack_require__(296540); }; }, 1);
			initExternal(639694);
			initExternal(41046);
			initExternal(37162);
			initExternal(899918);
			initExternal(99838);
			initExternal(538850);
			initExternal(367466);
			initExternal(610536);
			initExternal(211934);
			initExternal(52810);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(function() { return initPromises[name] = 1; });
};